import {
  SelfAttestedIncome,
  VerifiedIncomeReport
} from "types/landlord/reports";
import { formatToCurrency } from "utils/currency";
import { Section } from "views/applications-id-report/components/Section";
import { Stat } from "views/applications-id-report/components/Stat";

interface SelfReportedIncomeSummaryProps {
  report?: SelfAttestedIncome | null;
  verifiedReport?: VerifiedIncomeReport | null;
}

export const SelfReportedIncomeSummary = ({
  report,
  verifiedReport
}: SelfReportedIncomeSummaryProps) => {
  return (
    <Section sectionTitle="Self-reported income summary" maxWidth="none">
      <div className="grid md:grid-cols-3">
        <Stat
          title="Gross monthly income"
          value={
            report?.current_income?.cents
              ? formatToCurrency({
                  cents: report.current_income.cents,
                  currency: "USD"
                })
              : "-"
          }
        />
        <Stat
          title="Income sources"
          value={
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            report?.income_sources?.length
              ? String(report.income_sources.length)
              : "-"
          }
        />
        <Stat
          title="Monthly assistance amount"
          value={
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            verifiedReport?.housing_assistance_program?.voucher_amount?.cents
              ? formatToCurrency({
                  cents:
                    verifiedReport.housing_assistance_program.voucher_amount
                      .cents,
                  currency: "USD"
                })
              : "-"
          }
        />
      </div>
    </Section>
  );
};
